export const SET_AUTHENTICATION = "SET_AUTHENTICATION";
export const CLEAR_AUTHENTICATION = "CLEAR_AUTHENTICATION";
export const SET_AUTHENTICATION_ERROR = "SET_AUTHENTICATION_ERROR";
export const SET_SESSION_ID = "SET_SESSION_ID";